export const tr = {
    full: 'Tam',
    partial: 'Kısmi'
};
